'use strict';

angular.module('shiftTraderApp')
  .factory('httpInterceptor', function ($q, Session, uuid4) {
    return {
      request: function (config) {
        var token = Session.getAccessToken();
//      console.log('httpInterceptor token: ', token);
//      console.log(config.url);
        if (!_.has(config.headers, 'Authorization') || (!_.isUndefined(config.headers.Authorization) && config.headers.Authorization.indexOf('Basic') === -1)) {
          config.headers.Authorization = 'Bearer ' + token;
          if (Session.getSessionId()) {
            config.headers['X-SA-SESSION-ID'] = Session.getSessionId();
          }

          config.headers['X-SA-REQUEST-ID'] = uuid4.generate();
        }
        return config || $q.when(config);
      }
    };
  });

angular.module('shiftTraderApp')
  .config(function ($httpProvider) {
    $httpProvider.interceptors.push('httpInterceptor');
  });
